export default "__VITE_ASSET__Bqzf6rLW__"